<h3 class="card-page-header">
  {{ sdfCardLabels.basicInfoPage.header }} <br />
</h3>
<div *ngIf="isSdfCardFlow" class="card-page-header">
  <div class="card-inline-notification-wrapper">
    <div class="content-container">
      <img
        src="assets\images\master-notification.svg"
        alt="info-icon"
        class="info-icon"
      />
      <p class="content-body">{{ sdfCardLabels.common.notifcation.one }}.</p>
    </div>
  </div>
</div>

<form
  class="registration-form"
  [formGroup]="form"
  (ngSubmit)="submitted.emit(form.getRawValue())"
>
  <div class="registration-personal-info">
    <ng-container *ngFor="let field of personalFields; let fieldIndex = index">
      <ng-container *ngIf="field.name !== formFields.mobileNumber">
        <ng-container [ngSwitch]="field.controlType">
          <mat-form-field *ngSwitchCase="controlTypes?.INPUT">
            <!-- Span asterisk will only display if the field disabled and rrquired -->
            <mat-label
              >{{ field.fieldLabel
              }}<span
                *ngIf="field.required && form.controls[field.name!]?.disabled"
              >
                *</span
              ></mat-label
            >
            <input
              matInput
              [type]="field.controlType!"
              [formControlName]="field.name!"
            />
            <mat-error
              *ngIf="
                form.controls[field.name!]?.invalid &&
                (form.controls[field.name!]?.touched ||
                  form.controls[field.name!]?.dirty)
              "
            >
              <span
                *ngIf="
                  getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                "
              >
                {{ errorMsgToDisplay }}
              </span>
            </mat-error>
          </mat-form-field>
          <ng-container *ngSwitchCase="controlTypes?.DATE">
            <div class="dob-component">
              <label class="dob-label"
                >{{ labels?.stellar?.registration?.dateOfBirth
                }}<span> *</span></label
              >
              <!-- <app-date-of-birth [date]="senderData?.dateOfBirth" [parentForm]="form" (dateChanged)="onDateChanged($event)"></app-date-of-birth> -->
              <app-dob-dropdown
                [formControlName]="field.name!"
                [isDOBValid]="isDOBValid"
                [labels]="dateOfBirthComponent"
              ></app-dob-dropdown>
              <mat-error>
                <ng-container
                  *ngIf="
                    !form!.get('dateOfBirth')?.errors?.required &&
                    form!.get('dateOfBirth')?.errors?.invalidOption
                  "
                  >{{
                    labels?.stellar?.registration?.dateOfBirthComponent
                      ?.enterValidDOB
                  }}</ng-container
                >
                <ng-container
                  *ngIf="
                    !form!.get('dateOfBirth')?.errors?.required &&
                    form!.get('dateOfBirth')?.errors?.min
                  "
                  >{{
                    labels?.stellar?.registration?.errorMsgs?.min
                  }}</ng-container
                >
                <ng-container
                  *ngIf="
                    !form!.get('dateOfBirth')?.errors?.required &&
                    form!.get('dateOfBirth')?.errors?.max
                  "
                  >{{
                    labels?.stellar?.registration?.errorMsgs?.max
                  }}</ng-container
                >
              </mat-error>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="field.name === formFields.mobileNumber">
        <app-mobile-phone-number
          #phoneNumber
          class="phone-number-component"
          [parentForm]="form"
          [phoneFieldConfig]="mobileNumberConfig"
          [countryFieldConfig]="mobileCountryConfig"
          [phoneData]="phoneData"
          [transactionCountryCode]="transactionCountryCode"
          [locale]="locale"
          [labels]="labels"
        >
        </app-mobile-phone-number>
      </ng-container>
    </ng-container>
  </div>

  <div class="registration-button-row">
    <button
      color="primary"
      mat-raised-button
      type="submit"
      [disabled]="form.invalid || !!form.get('dateOfBirth')?.errors"
    >
      {{ labels.stellar.next }}
    </button>
  </div>
</form>
